import React from 'react';
import ErrorPage from './ErrorPage.js';

const BadRequest = () => (
  <ErrorPage
    code="400"
    title="Bad Request"
    message="The server could not understand your request. Please check the URL and try again."
  />
);

export default BadRequest;
